import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';

import { BookmarkModalContent } from '../../components/bookmark-modal/bookmark-modal-content';
import { useBookmark } from '../../context';

export const BookmarkModal: FC = () => {
	const { t } = useTranslation('bookmarks');
	const { isModalOpen, onCloseModal } = useBookmark();
	const handleBookmarkModalClose = () => {
		onCloseModal();
	};
	return (
		<Modal scrollBehavior="inside" onClose={handleBookmarkModalClose} isOpen={isModalOpen} size="lg" isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader borderBottomWidth={rem(1)} borderColor="gray.100" borderStyle="solid" color="gray.900">
					{t('bookmark_modal.edit_bookmark')}
				</ModalHeader>
				<ModalCloseButton size="lg" borderRadius="full" />
				<BookmarkModalContent />
			</ModalContent>
		</Modal>
	);
};
